import { render, staticRenderFns } from "./ShowArchivedButton.vue?vue&type=template&id=c37b80ac&"
import script from "./ShowArchivedButton.vue?vue&type=script&lang=js&"
export * from "./ShowArchivedButton.vue?vue&type=script&lang=js&"
import style0 from "./ShowArchivedButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports